import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { NotificationV2Service } from '@app/notification-v2.service';
import { CurrentUserService } from '@app/services/current-user.service';
import { submittalsSelectors } from '@app/store/submittals/submittals.selectors';
import { DayjsFormatterPipe } from '@app/pipes/framework/dayjs-formatter.pipe';
import { FileCardComponent } from '@app/framework/file-handling/file-card-component/file-card.component';
import { StatusPipe } from '@app/pipes/framework/status.pipe';
import { submittalPackageDetailsActions } from '@app/pages/webapp/projects/view-project/submittals/submittal-package-details-sidebar/submittal-package-details.actions';
import { LoadingSpinnerComponent } from '@app/framework/loading-animation/loading-spinner.component';

@Component({
  selector: 'app-submittal-package-transmittal-tab',
  imports: [
    FormsModule,
    DayjsFormatterPipe,
    FileCardComponent,
    StatusPipe,
    LoadingSpinnerComponent,
  ],
  templateUrl: './submittal-package-transmittal-tab.component.html',
  styleUrl: './submittal-package-transmittal-tab.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubmittalPackageTransmittalTabComponent implements OnInit {
  protected readonly notif = inject(NotificationV2Service);
  protected readonly store = inject(Store);
  protected readonly userService = inject(CurrentUserService);

  readonly submittalPackage = toSignal(this.store.select(submittalsSelectors.selectPackageDetails));
  readonly transmittalLogs = toSignal(
    this.store.select(submittalsSelectors.selectSubmittalTransmittalLogs),
  );
  readonly isLoading = toSignal(
    this.store.select(submittalsSelectors.selectSubmittalTransmittalLogsLoading),
  );

  ngOnInit(): void {
    this.store.dispatch(submittalPackageDetailsActions.transmittalLogsAccessed());
  }
}
